import {Collection} from 'vue-mc'
import {WelcomePageModel} from '@/models/welcomePageModel'

/**
 * welcomePageCollections collection
 */

export default class welcomePageCollections extends Collection {

	// Default attributes that define the "empty" state.
	defaults() {
		return {

		}
	}

	model() {
		return WelcomePageModel;
	}

	// Route configuration
	routes() {
		return {
			fetch: "clients/welcomePage"
		}
	}
}



// WEBPACK FOOTER //
// ./src/collections/welcomePageCollections.js